import { Fragment } from "react";

import BaseComponent from "@js/components/base_component.jsx";

class MuiUserSettingsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isChangingPassword: props.entity.is_changing_password,
    };
  }

  render() {
    return (
      <div>
        <ErrorBanner entity={ this.props.entity } />

        {
          !this.props.entity.is_sudo_user && (
            <Panel heading="user_details">
              <div className="form-horizontal">
                <InputField
                  object={ this.props.entity }
                  type="mui_user_settings"
                  field="name"
                  editing={ this.props.editing }
                />

                { this._renderPasswordChange() }
              </div>
            </Panel>
          )
        }

        {
          this.props.entity.account_details &&
            <Panel heading="account_details">
              <div className="form-horizontal">
                <input type="hidden" name="mui_user_settings[update_account_using_user_role_id]" value={ this.props.entity.account_details.user_role_id } />

                <SelectField
                  field="mui_user_settings.update_account_time_zone_name"
                  value={ this.props.entity.account_details.time_zone_name }
                  options={ this.props.entity.account_details.available_time_zones }
                  editing={ this.props.editing }
                  onChange={ () => {} }
                  error={ this.props.entity.errors ? this.props.entity.errors.account_time_zone_name : null }
                />
              </div>
            </Panel>
        }
      </div>
    );
  }

  _renderPasswordChange() {
    if ( !this.props.editing ) {
      return null;
    }

    if ( !this.state.isChangingPassword ) {
      return (
        <div>
          <div className="col-sm-4"></div>
          <div className="col-sm-8">
            <a
              href="#"
              onClick={ (e) => { e.preventDefault(); this.setState({ isChangingPassword: true }); } }
            >{ t("phrases.click_here_to_change_your_password") }</a>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <hr/>
        <input
          type="hidden"
          name="mui_user_settings[is_changing_password]"
          value="1"
        />
        <InputField
          object={ this.props.entity }
          type="mui_user_settings"
          field="current_password"
          editing={ this.props.editing }
          password={ true }
        />
        <InputField
          object={ this.props.entity }
          type="mui_user_settings"
          field="new_password1"
          editing={ this.props.editing }
          password={ true }
        />
        <InputField
          object={ this.props.entity }
          type="mui_user_settings"
          field="new_password2"
          editing={ this.props.editing }
          password={ true }
        />
      </Fragment>
    );
  }

}

export default MuiUserSettingsForm;
